import React from "react";
import { Modale, ModaleContent, ModaleTitre } from "../../../Modale";
import { Fieldset, BoutonRadio } from "../../../Form";
import dark from "@gouvfr/dsfr/dist/artwork/dark.svg";
import light from "@gouvfr/dsfr/dist/artwork/light.svg";
import system from "@gouvfr/dsfr/dist/artwork/system.svg";
import useLocalStorage from "../Hooks/useLocalStorage";
import Artwork from "../../../../technical-fundamental/Artwork/Artwork";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025.
 */
var ModaleParametreAffichage = function (_a) {
    var closeCallback = _a.closeCallback, changerThemeCallback = _a.changerThemeCallback;
    var _b = useLocalStorage("scheme", "system"), scheme = _b[0], setScheme = _b[1];
    var onChangeTheme = function (event) {
        setScheme(event.target.value);
        changerThemeCallback(event.target.value);
    };
    var themes = [
        {
            nom: "light",
            label: "Thème clair",
            texteAide: "",
            image: light,
        },
        {
            nom: "dark",
            label: "Thème sombre",
            texteAide: "",
            image: dark,
        },
        {
            nom: "system",
            label: "Système",
            texteAide: "Utilise les paramètres système.",
            image: system,
        },
    ];
    return (React.createElement(Modale, { id: "parametre-affichage-footer", closeCallback: closeCallback },
        React.createElement(ModaleTitre, { idModale: "parametre-affichage-footer" }, "Param\u00E8tres d'affichage"),
        React.createElement(ModaleContent, null,
            React.createElement(Fieldset, { id: "parametre-affichage-fieldset", legende: "Choisissez un th\u00E8me pour personnaliser l'apparence du site." }, themes.map(function (theme) {
                var _a;
                return (React.createElement(BoutonRadio, { key: theme.nom, value: theme.nom, checked: scheme === theme.nom, id: "fr-radios-theme-".concat(theme.nom), name: "fr-radios-theme", label: theme.label, texteAide: theme.texteAide, image: React.createElement(Artwork, { svg: (_a = theme.image.src) !== null && _a !== void 0 ? _a : theme.image, size: "5rem" }), onChange: onChangeTheme }));
            })))));
};
export default ModaleParametreAffichage;
